import { drawPosterCanvas } from "../../../utils/posterCanvas.js";

function safeFilename(title, maxLen) {
  return (title || "recette")
    .replace(/[^a-zA-Z0-9\u00C0-\u024F\s-]/g, "")
    .replace(/\s+/g, "-")
    .slice(0, maxLen);
}

export function createDownloadPng(
  selectedRecipe,
  selectedTemplate,
  user,
  preloadedImageUrl,
  logoDataUrl,
  setDownloading,
  setError,
) {
  return async () => {
    if (!selectedRecipe) return;
    setDownloading(true);
    setError(null);
    try {
      const canvas = await drawPosterCanvas({
        recipe: selectedRecipe,
        templateId: selectedTemplate,
        userName: user?.first_name || user?.username,
        imageDataUrl: preloadedImageUrl,
        logoDataUrl,
      });
      if (!canvas) throw new Error("Génération échouée");
      const link = document.createElement("a");
      link.download = `JesCook-${safeFilename(selectedRecipe.title, 30) || "recette"}.png`;
      link.href = canvas.toDataURL("image/png");
      link.click();
    } catch (err) {
      setError(err.message || "Erreur export");
    } finally {
      setDownloading(false);
    }
  };
}
